module.exports = "<ui-form-element\n    [title]=\"title\"\n    [description]=\"description\"\n    [highlightPhrase]=\"highlightPhrase\">\n\n     <ui-switcher [id]=\"id\"\n                  [disabled]=\"disabled\"\n                  (click)=\"clicked($event)\"\n                  [(ngModel)]=\"innerValue\">\n     </ui-switcher>\n\n</ui-form-element>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/form-elements/fe-switcher/fe-switcher.html
// module id = 1090
// module chunks = 3